import { PageFlip } from 'page-flip';

const instances = {};  // id -> PageFlip instance | 'loading' | null
const zoomControllers = {};
const ZOOM_MIN = 1;
const ZOOM_MAX = 4;
const ZOOM_STEP = 0.5;

function getImages(aside) {
    const tag = aside.querySelector('[data-flipbook-images]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
}

function calcDimensions(pdfAspect) {
    const availW = window.innerWidth;
    const availH = window.innerHeight - 140;
    const useSinglePage = availH > availW || availW < 1024;

    let pageW, pageH;

    if (useSinglePage) {
        pageW = availW * 0.88;
        pageH = pageW * pdfAspect;
        if (pageH > availH) { pageH = availH; pageW = pageH / pdfAspect; }
    } else {
        pageW = (availW * 0.90) / 2;
        pageH = pageW * pdfAspect;
        if (pageH > availH) { pageH = availH; pageW = pageH / pdfAspect; }
    }

    return { pageW: Math.round(pageW), pageH: Math.round(pageH), useSinglePage };
}

function mountPageFlip(aside, images) {
    const id = aside.id;
    const stage = aside.querySelector('[data-flipbook-stage]');
    if (!stage) return;
    const { pageW, pageH, useSinglePage } = calcDimensions(images[0].h / images[0].w);

    const pageFlip = new PageFlip(stage, {
        width: pageW,
        height: pageH,
        size: 'fixed',
        drawShadow: true,
        maxShadowOpacity: 0.4,
        showCover: true,
        mobileScrollSupport: false,
        usePortrait: useSinglePage,
        startZIndex: 1,
        flippingTime: 800,
    });

    const pageElements = images.map(function (p) {
        const img = document.createElement('img');
        img.src = p.url;
        img.style.cssText = 'width:100%;height:100%;display:block;object-fit:fill;';
        return img;
    });

    pageFlip.loadFromHTML(pageElements);
    instances[id] = pageFlip;

    pageFlip.on('init', function () {
        aside.setAttribute('data-loaded', 'true');
        buildThumbnails(aside, images);
        updateActiveThumbnail(aside, 0);
        updateCoverCentering(aside, pageFlip, useSinglePage, true);
    });

    const zoomControls = aside.querySelector('[data-flipbook-zoom]');
    if (zoomControls) zoomControls.hidden = useSinglePage;

    updateInfo(aside, pageFlip);
    pageFlip.on('flip', function () {
        updateInfo(aside, pageFlip);
        updateActiveThumbnail(aside, pageFlip.getCurrentPageIndex());
        updateCoverCentering(aside, pageFlip, useSinglePage, false);
    });

    initZoom(aside, stage);
    initThumbSwipeClose(aside);
}

function createZoom(aside, stage) {
	var scale = 1;
	var tx = 0;
	var ty = 0;
	var cleanup = [];

	function updateButtons() {
		var outBtn = aside.querySelector('[data-flipbook-zoom-out]');
		var inBtn = aside.querySelector('[data-flipbook-zoom-in]');
		if (outBtn) outBtn.disabled = scale <= ZOOM_MIN;
		if (inBtn) inBtn.disabled = scale >= ZOOM_MAX;
	}

	function apply() {
		stage.dataset.zoomScale = String(scale);
		stage.dataset.zoomTx = String(tx);
		stage.dataset.zoomTy = String(ty);
		stage.style.transition = 'none';
		applyBookTransform(stage);
		updateButtons();
	}

	function clamp() {
		var mTx = stage.offsetWidth * (scale - 1) / (2 * scale);
		var mTy = stage.offsetHeight * (scale - 1) / (2 * scale);
		tx = Math.max(-mTx, Math.min(mTx, tx));
		ty = Math.max(-mTy, Math.min(mTy, ty));
	}

	function setScale(next) {
		scale = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, next));
		if (scale < 1.01) {
			scale = 1;
			tx = 0;
			ty = 0;
		}
		clamp();
		apply();
	}

	apply();

	return {
		getScale: function () { return scale; },
		setScale: setScale,
		zoomBy: function (direction) {
			var index = Math.floor((scale - ZOOM_MIN) / ZOOM_STEP + 0.001);
			setScale(ZOOM_MIN + (index + direction) * ZOOM_STEP);
		},
		panFrom: function (originX, originY, baseTx, baseTy, clientX, clientY) {
			tx = baseTx + (clientX - originX) / scale;
			ty = baseTy + (clientY - originY) / scale;
			clamp();
			apply();
		},
		getPan: function () { return { tx: tx, ty: ty }; },
		isZoomed: function () { return scale > 1.05; },
		reset: function () {
			scale = 1;
			tx = 0;
			ty = 0;
			delete stage.dataset.panning;
			apply();
		},
		addCleanup: function (fn) { cleanup.push(fn); },
		destroy: function () {
			cleanup.forEach(function (fn) { fn(); });
			cleanup = [];
		}
	};
}

function bindTouchZoom(stage, zoom) {
	var pinchDist = 0;
	var pinching = false;
	var panning = false;
	var blockUntil = 0;
	var panOriginX = 0;
	var panOriginY = 0;
	var panBaseTx = 0;
	var panBaseTy = 0;

	function blocked() { return Date.now() < blockUntil; }
	function block(ms) { blockUntil = Date.now() + ms; }

	stage.addEventListener('touchstart', function (e) {
		if (e.touches.length >= 2) {
			pinching = true;
			pinchDist = Math.hypot(
				e.touches[1].clientX - e.touches[0].clientX,
				e.touches[1].clientY - e.touches[0].clientY
			);
			e.preventDefault();
			e.stopImmediatePropagation();
		} else if (e.touches.length === 1 && (zoom.isZoomed() || blocked())) {
			panning = true;
			panOriginX = e.touches[0].clientX;
			panOriginY = e.touches[0].clientY;
			var pan = zoom.getPan();
			panBaseTx = pan.tx;
			panBaseTy = pan.ty;
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	}, { capture: true, passive: false });

	stage.addEventListener('touchmove', function (e) {
		if (pinching && e.touches.length >= 2) {
			var d = Math.hypot(
				e.touches[1].clientX - e.touches[0].clientX,
				e.touches[1].clientY - e.touches[0].clientY
			);
			if (pinchDist > 0) {
				zoom.setScale(zoom.getScale() * (d / pinchDist));
			}
			pinchDist = d;
			e.preventDefault();
			e.stopImmediatePropagation();
		} else if (panning && e.touches.length === 1) {
			zoom.panFrom(panOriginX, panOriginY, panBaseTx, panBaseTy, e.touches[0].clientX, e.touches[0].clientY);
			e.preventDefault();
			e.stopImmediatePropagation();
		} else if (blocked()) {
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	}, { capture: true, passive: false });

	stage.addEventListener('touchend', function (e) {
		if (pinching && e.touches.length < 2) {
			pinching = false;
			panning = false;
			pinchDist = 0;
			if (zoom.getScale() < 1.1) zoom.setScale(1);
			block(400);
			e.preventDefault();
			e.stopImmediatePropagation();
			return;
		}
		if (panning) {
			panning = false;
			e.preventDefault();
			e.stopImmediatePropagation();
			return;
		}
		if (blocked()) {
			e.preventDefault();
			e.stopImmediatePropagation();
			return;
		}
	}, { capture: true, passive: false });
}

function bindMousePan(stage, zoom) {
	var panning = false;
	var dragged = false;
	var originX = 0;
	var originY = 0;
	var baseTx = 0;
	var baseTy = 0;

	function swallowClick(e) {
		e.preventDefault();
		e.stopPropagation();
		window.clearTimeout(swallowTimer);
		window.removeEventListener('click', swallowClick, { capture: true });
	}

	function onMouseDown(e) {
		if (e.button !== 0 || !zoom.isZoomed()) return;
		panning = true;
		dragged = false;
		originX = e.clientX;
		originY = e.clientY;
		var pan = zoom.getPan();
		baseTx = pan.tx;
		baseTy = pan.ty;
		stage.dataset.panning = 'true';
		e.preventDefault();
		e.stopPropagation();
	}

	function onMouseMove(e) {
		if (!zoom.isZoomed()) return;
		if (panning) {
			if (Math.abs(e.clientX - originX) > 3 || Math.abs(e.clientY - originY) > 3) dragged = true;
			zoom.panFrom(originX, originY, baseTx, baseTy, e.clientX, e.clientY);
			e.preventDefault();
			e.stopPropagation();
			return;
		}
		if (e.target instanceof Node && stage.contains(e.target)) {
			e.stopPropagation();
		}
	}

	var swallowTimer = 0;

	function onMouseUp() {
		if (!panning) return;
		panning = false;
		delete stage.dataset.panning;
		if (!dragged) return;
		window.addEventListener('click', swallowClick, { capture: true });
		swallowTimer = window.setTimeout(function () {
			window.removeEventListener('click', swallowClick, { capture: true });
		}, 400);
	}

	stage.addEventListener('mousedown', onMouseDown, { capture: true });
	window.addEventListener('mousemove', onMouseMove, { capture: true });
	window.addEventListener('mouseup', onMouseUp);
	zoom.addCleanup(function () {
		stage.removeEventListener('mousedown', onMouseDown, { capture: true });
		window.removeEventListener('mousemove', onMouseMove, { capture: true });
		window.removeEventListener('mouseup', onMouseUp);
		window.removeEventListener('click', swallowClick, { capture: true });
		window.clearTimeout(swallowTimer);
	});
}

function bindWheelZoom(aside, stage, zoom) {
	var acc = 0;
	var resetTimer = 0;

	function onWheel(e) {
		var controls = aside.querySelector('[data-flipbook-zoom]');
		if (!controls || controls.hidden) return;
		if (e.target instanceof Element && e.target.closest('.flipbook-thumbs, [data-flipbook-share-popup]')) return;
		e.preventDefault();
		window.clearTimeout(resetTimer);
		resetTimer = window.setTimeout(function () { acc = 0; }, 160);
		if (e.deltaMode !== 0) {
			if (e.deltaY === 0) return;
			acc = 0;
			zoom.zoomBy(e.deltaY > 0 ? -1 : 1);
			return;
		}
		acc += e.deltaY;
		if (Math.abs(acc) < 80) return;
		zoom.zoomBy(acc > 0 ? -1 : 1);
		acc = 0;
	}

	stage.addEventListener('wheel', onWheel, { passive: false });
	zoom.addCleanup(function () {
		window.clearTimeout(resetTimer);
		stage.removeEventListener('wheel', onWheel);
	});
}

function initZoom(aside, stage) {
	var zoom = createZoom(aside, stage);
	zoomControllers[aside.id] = zoom;

	if ('ontouchstart' in window) {
		bindTouchZoom(stage, zoom);
		showZoomHint(aside);
	}

	if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
		bindMousePan(stage, zoom);
		bindWheelZoom(aside, stage, zoom);
	}
}

function applyBookTransform(stage) {
	var shift = stage.dataset.coverShift || '';
	var scale = parseFloat(stage.dataset.zoomScale || '1');
	var tx = stage.dataset.zoomTx || '0';
	var ty = stage.dataset.zoomTy || '0';
	if (scale > 1) {
		stage.style.transform = (shift ? shift + ' ' : '') + 'scale(' + scale + ') translate(' + tx + 'px,' + ty + 'px)';
		stage.dataset.zoomed = 'true';
	} else {
		stage.style.transform = shift;
		delete stage.dataset.zoomed;
	}
}

function showZoomHint(aside) {
    var hint = document.createElement('div');
    hint.className = 'flipbook-hint';
    hint.innerHTML =
        '<div class="flipbook-hint-item">' +
            '<svg viewBox="0 0 60 24" fill="none" aria-hidden="true">' +
                '<circle class="hint-finger-l" cx="14" cy="12" r="7" stroke="currentColor" stroke-width="1.5"/>' +
                '<circle class="hint-finger-r" cx="46" cy="12" r="7" stroke="currentColor" stroke-width="1.5"/>' +
            '</svg>' +
            '<span>Pinch to zoom</span>' +
        '</div>' +
        '<div class="flipbook-hint-divider"></div>' +
        '<div class="flipbook-hint-item">' +
            '<svg viewBox="0 0 48 24" fill="none" aria-hidden="true">' +
                '<circle class="hint-finger-pan" cx="10" cy="12" r="7" stroke="currentColor" stroke-width="1.5"/>' +
            '</svg>' +
            '<span>Drag to pan</span>' +
        '</div>' +
        '<div class="flipbook-hint-divider"></div>' +
        '<div class="flipbook-hint-item">' +
            '<svg viewBox="0 0 52 24" fill="none" aria-hidden="true">' +
                '<line x1="47" y1="3" x2="47" y2="21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.4"/>' +
                '<rect class="hint-swipe-trail" x="14" y="11" width="33" height="2" fill="currentColor" rx="1"/>' +
                '<circle class="hint-finger-swipe" cx="40" cy="12" r="7" stroke="currentColor" stroke-width="1.5"/>' +
            '</svg>' +
            '<span>Swipe edge to flip</span>' +
        '</div>';

    (aside.querySelector('.stf__parent') || aside.querySelector('.flipbook-stage')).appendChild(hint);

    setTimeout(function () {
        hint.classList.add('flipbook-hint--out');
        setTimeout(function () { hint.remove(); }, 500);
    }, 3500);
}

function destroyFlipbook(id) {
    const inst = instances[id];
    if (inst && inst !== 'loading') {
        try { inst.destroy(); } catch (e) {}
    }
    instances[id] = null;

    if (zoomControllers[id]) {
        zoomControllers[id].destroy();
        delete zoomControllers[id];
    }

    const aside = document.getElementById(id);
    if (!aside) return;
    aside.removeAttribute('data-loaded');
    const oldStage = aside.querySelector('[data-flipbook-stage]');
    const newStage = document.createElement('div');
    newStage.className = 'flipbook-stage';
    newStage.setAttribute('data-flipbook-stage', '');
    if (oldStage) {
        oldStage.replaceWith(newStage);
    } else {
        aside.querySelector('.flipbook-inner').appendChild(newStage);
    }
}

function initFlipbook(aside) {
    const id = aside.id;
    if (instances[id]) return;
    instances[id] = 'loading';

    const images = getImages(aside);
    if (!images || !images.length) {
        instances[id] = null;
        const loading = aside.querySelector('.flipbook-loading');
        if (loading) loading.innerHTML = '<p class="p3">Could not load document.</p>';
        return;
    }

    mountPageFlip(aside, images);
}

function updateInfo(aside, pageFlip) {
    const el = aside.querySelector('[data-flipbook-info]');
    if (el) el.textContent = (pageFlip.getCurrentPageIndex() + 1) + ' / ' + pageFlip.getPageCount();
}

function updateCoverCentering(aside, pageFlip, useSinglePage, instant) {
    if (useSinglePage) return;
    const current = pageFlip.getCurrentPageIndex();
    const last = pageFlip.getPageCount() - 1;

    const apply = function () {
        const stfParent = aside.querySelector('.stf__parent');
        if (!stfParent) return;
        stfParent.style.transition = instant ? 'none' : 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        if (current === 0) {
            stfParent.dataset.coverShift = 'translateX(-25%)';
        } else if (current === last) {
            stfParent.dataset.coverShift = 'translateX(25%)';
        } else {
            delete stfParent.dataset.coverShift;
        }
        applyBookTransform(stfParent);
    };

    if (instant) {
        apply();
    } else {
        // Double rAF: lets StPageFlip commit its final DOM state before we change the transform,
        // so the browser sees a genuine from→to delta and plays the CSS transition.
        requestAnimationFrame(function () { requestAnimationFrame(apply); });
    }
}

function initThumbSwipeClose(aside) {
    const panel = aside.querySelector('[data-flipbook-thumbs]');
    if (!panel) return;
    var startX = 0;
    panel.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
    }, { passive: true });
    panel.addEventListener('touchend', function (e) {
        if (e.changedTouches[0].clientX - startX < -50) {
            panel.dataset.open = 'false';
            const btn = aside.querySelector('.flipbook-toolbar-btn[data-flipbook-thumbnails]');
            if (btn) btn.dataset.active = 'false';
        }
    }, { passive: true });
}

function buildThumbnails(aside, images) {
    const list = aside.querySelector('[data-flipbook-thumbs-list]');
    if (!list || list.hasChildNodes()) return;
    images.forEach(function (img, i) {
        const btn = document.createElement('button');
        btn.className = 'flipbook-thumb-item';
        btn.dataset.flipbookThumb = i;
        btn.setAttribute('aria-label', 'Go to page ' + (i + 1));

        const imgEl = document.createElement('img');
        imgEl.src = img.thumb || img.url;
        imgEl.loading = 'lazy';
        imgEl.alt = '';

        const num = document.createElement('span');
        num.className = 'flipbook-thumb-num';
        num.textContent = i + 1;

        btn.appendChild(imgEl);
        btn.appendChild(num);
        list.appendChild(btn);
    });
}

function updateActiveThumbnail(aside, index) {
    const list = aside.querySelector('[data-flipbook-thumbs-list]');
    if (!list) return;
    list.querySelectorAll('.flipbook-thumb-item').forEach(function (btn) {
        btn.dataset.active = String(Number(btn.dataset.flipbookThumb) === index);
    });
    const active = list.querySelector('[data-active="true"]');
    if (active) active.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
}

function closeSharePopup(aside) {
    const popup = aside.querySelector('[data-flipbook-share-popup]');
    if (popup) popup.dataset.open = 'false';
    const btn = aside.querySelector('[data-flipbook-share]');
    if (btn) btn.dataset.active = 'false';
}

function closeFlipbook(aside) {
    aside.setAttribute('data-popup-revealed', 'false');
    aside.setAttribute('data-container-revealed', 'false');
    closeSharePopup(aside);
    document.body.setAttribute('data-menu-revealed', 'false');
    window.lenis && window.lenis.start();
}

function openFlipbook(hash) {
    if (!hash || !hash.startsWith('#flipbook-')) return false;
    const id = hash.slice(1);
    const aside = document.getElementById(id);
    if (!aside || !aside.classList.contains('flipbook-popup')) return false;

    window.lenis && window.lenis.stop();
    document.body.setAttribute('data-menu-revealed', 'true');
    aside.setAttribute('data-popup-revealed', 'true');
    aside.setAttribute('data-container-revealed', 'true');

    setTimeout(() => initFlipbook(aside), 750);
    return true;
}

let resizeTimer;
window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        document.querySelectorAll('aside.flipbook-popup').forEach(function (aside) {
            const id = aside.id;
            const isOpen = aside.getAttribute('data-popup-revealed') === 'true';
            destroyFlipbook(id);
            if (isOpen) {
                const images = getImages(aside);
                if (images && images.length) mountPageFlip(aside, images);
            }
        });
    }, 300);
});

// StPageFlip attaches its mousemove tracker at the document bubble phase.
// We intercept at capture phase so it never fires when the mouse is over an open thumbnail panel.
document.addEventListener('mousemove', function (e) {
    const panel = document.querySelector('aside.flipbook-popup .flipbook-thumbs[data-open="true"]');
    if (!panel) return;
    const rect = panel.getBoundingClientRect();
    if (e.clientX >= rect.left && e.clientX <= rect.right &&
        e.clientY >= rect.top && e.clientY <= rect.bottom) {
        e.stopPropagation();
    }
}, { capture: true });

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('aside.flipbook-popup').forEach(function (aside) {
        document.body.appendChild(aside);
    });
    openFlipbook(window.location.hash);
});

window.addEventListener('hashchange', function (e) {
    const newHash = new URL(e.newURL).hash;
    if (newHash.startsWith('#flipbook-')) { openFlipbook(newHash); }
});

window.addEventListener('popstate', function () {
    if (!window.location.hash.startsWith('#flipbook-')) {
        const open = document.querySelector('aside.flipbook-popup[data-popup-revealed="true"]');
        if (open) closeFlipbook(open);
    }
});

document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href^="#flipbook-"]');
    if (!link) return;
    e.preventDefault();
    const hash = '#' + link.getAttribute('href').split('#')[1];
    history.pushState(null, '', hash);
    openFlipbook(hash);
});

document.addEventListener('click', function (e) {
    const zoomIn = e.target.closest('[data-flipbook-zoom-in]');
    const zoomOut = e.target.closest('[data-flipbook-zoom-out]');
    if (zoomIn || zoomOut) {
        const aside = (zoomIn || zoomOut).closest('.flipbook-popup');
        const zoom = aside && zoomControllers[aside.id];
        if (zoom) zoom.zoomBy(zoomIn ? 1 : -1);
        return;
    }

    // Close share popup when clicking outside it
    if (!e.target.closest('[data-flipbook-share-popup]') && !e.target.closest('[data-flipbook-share]')) {
        document.querySelectorAll('[data-flipbook-share-popup][data-open="true"]').forEach(function (popup) {
            popup.dataset.open = 'false';
            const aside = popup.closest('.flipbook-popup');
            if (aside) {
                const btn = aside.querySelector('[data-flipbook-share]');
                if (btn) btn.dataset.active = 'false';
            }
        });
    }

    const shareBtn = e.target.closest('[data-flipbook-share]');
    if (shareBtn) {
        const aside = shareBtn.closest('.flipbook-popup');
        if (!aside) return;
        const popup = aside.querySelector('[data-flipbook-share-popup]');
        if (!popup) return;
        const isOpen = popup.dataset.open === 'true';
        if (!isOpen) {
            const url = window.location.origin + window.location.pathname + '#' + aside.id;
            const enc = encodeURIComponent(url);
            const input = popup.querySelector('[data-flipbook-share-url]');
            if (input) input.value = url;
            requestAnimationFrame(function() { if (input) input.select(); });
            const links = {
                facebook:  'https://www.facebook.com/sharer/sharer.php?u=' + enc,
                twitter:   'https://twitter.com/intent/tweet?url=' + enc,
                whatsapp:  'https://wa.me/?text=' + enc,
                linkedin:  'https://www.linkedin.com/sharing/share-offsite/?url=' + enc,
                pinterest: 'https://pinterest.com/pin/create/button/?url=' + enc,
                email:     'mailto:?subject=I%20wanted%20you%20to%20see%20this%20FlipBook&body=Check%20out%20this%20site%20' + enc
            };
            popup.querySelectorAll('[data-share]').forEach(function (a) {
                if (links[a.dataset.share]) a.href = links[a.dataset.share];
            });
        }
        popup.dataset.open = isOpen ? 'false' : 'true';
        shareBtn.dataset.active = isOpen ? 'false' : 'true';
        return;
    }

    const thumbToggle = e.target.closest('[data-flipbook-thumbnails]');
    if (thumbToggle) {
        const aside = thumbToggle.closest('.flipbook-popup');
        if (!aside) return;
        const panel = aside.querySelector('[data-flipbook-thumbs]');
        const toolbarBtn = aside.querySelector('.flipbook-toolbar-btn[data-flipbook-thumbnails]');
        const isOpen = panel && panel.dataset.open === 'true';
        if (panel) panel.dataset.open = isOpen ? 'false' : 'true';
        if (toolbarBtn) toolbarBtn.dataset.active = isOpen ? 'false' : 'true';
        return;
    }
    const thumb = e.target.closest('[data-flipbook-thumb]');
    if (thumb) {
        const aside = thumb.closest('.flipbook-popup');
        const inst = aside && instances[aside.id];
        if (inst && inst !== 'loading') inst.flip(Number(thumb.dataset.flipbookThumb));
        return;
    }

    const prev = e.target.closest('[data-flipbook-prev]');
    if (prev) {
        const aside = prev.closest('.flipbook-popup');
        const inst = aside && instances[aside.id];
        if (inst && inst !== 'loading') inst.flipPrev();
        return;
    }
    const next = e.target.closest('[data-flipbook-next]');
    if (next) {
        const aside = next.closest('.flipbook-popup');
        const inst = aside && instances[aside.id];
        if (inst && inst !== 'loading') inst.flipNext();
        return;
    }
    const first = e.target.closest('[data-flipbook-first]');
    if (first) {
        const aside = first.closest('.flipbook-popup');
        const inst = aside && instances[aside.id];
        if (inst && inst !== 'loading') inst.flip(0);
        return;
    }
    const last = e.target.closest('[data-flipbook-last]');
    if (last) {
        const aside = last.closest('.flipbook-popup');
        const inst = aside && instances[aside.id];
        if (inst && inst !== 'loading') inst.flip(inst.getPageCount() - 1);
        return;
    }
});

document.addEventListener('click', function (e) {
    const urlInput = e.target.closest('[data-flipbook-share-url]');
    if (urlInput) { urlInput.select(); return; }
});

document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-flipbook-share-popup][data-open="true"]').forEach(function (popup) {
        popup.dataset.open = 'false';
        const aside = popup.closest('.flipbook-popup');
        if (aside) {
            const btn = aside.querySelector('[data-flipbook-share]');
            if (btn) btn.dataset.active = 'false';
        }
    });
});

document.addEventListener('click', function (e) {
    if (e.target.closest('[data-trigger-popup-close]')) {
        const aside = e.target.closest('.flipbook-popup');
        if (aside) {
            if (zoomControllers[aside.id]) zoomControllers[aside.id].reset();
            closeFlipbook(aside);
        }
        history.replaceState(null, '', window.location.pathname + window.location.search);
    }
});
